module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ./~/browserify-sign/algos.js
// module id = 295
// module chunks = 2